"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEmptyOption = void 0;
const getEmptyOption = (label) => ({
    label: `Choose ${label}`,
    value: null,
});
exports.getEmptyOption = getEmptyOption;
